<template>
  <div>
    <v-alert outlined color="black">
      <div class="text-h6 text-center">Coming Soon</div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
};
</script>
